// extracted by mini-css-extract-plugin
module.exports = {"modalPolicyContainer":"policy-module--modalPolicyContainer--3yufp","modalPolicyClose":"policy-module--modalPolicyClose--hH79y"};